import { render, staticRenderFns } from "./AdvisorPreference.vue?vue&type=template&id=2ebcb2e9"
import script from "./AdvisorPreference.vue?vue&type=script&lang=js"
export * from "./AdvisorPreference.vue?vue&type=script&lang=js"
import style0 from "./AdvisorPreference.vue?vue&type=style&index=0&id=2ebcb2e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports